import {
  DEFAULT_SCHEDULE_ZOOM_INTERVAL,
  SCHEDULE_ZOOM_INTERVALS,
  type ScheduleZoomInterval,
} from '../Calendar/ZoomControls/scheduleZoomIntervals'
import {
  isSchedulePreferenceUserId,
  readSchedulePreferences,
  updateSchedulePreferences,
} from './schedulePreferencesStorage'

const isScheduleZoomInterval = (value: unknown): value is ScheduleZoomInterval =>
  (SCHEDULE_ZOOM_INTERVALS as readonly number[]).includes(Number(value))

const readStoredZoom = (value: unknown): ScheduleZoomInterval | null => {
  if (isScheduleZoomInterval(value)) return value
  if (!value || typeof value !== 'object') return null
  const legacy = value as { day?: unknown; week?: unknown }
  if (isScheduleZoomInterval(legacy.day)) return legacy.day
  if (isScheduleZoomInterval(legacy.week)) return legacy.week
  return null
}

export const getScheduleZoomInterval = (
  userId: number | null | undefined,
): ScheduleZoomInterval => {
  if (!isSchedulePreferenceUserId(userId)) return DEFAULT_SCHEDULE_ZOOM_INTERVAL
  const stored = readStoredZoom(readSchedulePreferences()[String(userId)]?.zoom)
  return stored ?? DEFAULT_SCHEDULE_ZOOM_INTERVAL
}

export const setScheduleZoomInterval = (
  userId: number | null | undefined,
  interval: number,
): ScheduleZoomInterval => {
  const next = isScheduleZoomInterval(interval) ? interval : DEFAULT_SCHEDULE_ZOOM_INTERVAL
  if (!isSchedulePreferenceUserId(userId)) return next
  updateSchedulePreferences(userId, (current) => ({ ...current, zoom: next }))
  return next
}
